// Entitlements: which modules a company has on, on trial, or locked (roadmap §3.3).
// Stored at <settings>/modules for the company (legacy: settings/modules at the root).
// Shape: { modules: { [id]: 'active' | 'locked' | { state: 'trial', endsAt: ISO } }, updatedAt }
// Core-bundle modules are always active; a missing document means "nothing else is on".
import type { Entitlements } from './index.js';

export const ENTITLEMENTS_DOC = 'modules';

export function withDefaults(stored: Entitlements | null | undefined, coreIds: readonly string[]): Entitlements {
  const modules: Entitlements['modules'] = { ...(stored?.modules ?? {}) };
  for (const id of coreIds) modules[id] = 'active';
  // Expired trials read as locked.
  for (const [id, v] of Object.entries(modules)) {
    if (typeof v === 'object' && v.state === 'trial' && new Date(v.endsAt).getTime() < Date.now()) modules[id] = 'locked';
  }
  return { modules };
}

export function startTrial(ent: Entitlements, id: string, days = 14): Entitlements {
  const endsAt = new Date(Date.now() + days * 86_400_000).toISOString();
  return { modules: { ...ent.modules, [id]: { state: 'trial', endsAt } } };
}

export function setModule(ent: Entitlements, id: string, state: 'active' | 'locked'): Entitlements {
  return { modules: { ...ent.modules, [id]: state } };
}
